import React from 'react'
import styled from '@src/styled-components'
import { Button, Modal } from 'antd';
import { withRouter } from 'react-router-dom'

import { LocalStorageKeys } from './App';
import TableComponent from '@components/TableComponent';
import DashboardService from '@services/Dashboard';
import I18n from '@src/i18n';
import DashboardForm from '@components/DashboardForm';
import NotificationComponent from '@src/helpers/_showNotifications';
import verifyItemPermission from '@src/helpers/verifyItemPermission';

class Dashboard extends React.Component<any, any> {
  private idUnit: any = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
  private currentPillar: string = String(localStorage.getItem(LocalStorageKeys.PILLAR))
  private tableColumns: any = [{
    title: 'table.formflow.name',
    dataIndex: 'title',
    key: 'title',
    class: 'title'
  }, {
    title: 'table.actions',
    dataIndex: 'action',
    key: 'action',
    width: '20%'
  }]
  private dashboardService: any = new DashboardService()
  private dashboardModel = { title: '', groupId: [] }

  constructor(props: any) {
    super(props)

    this.state = {
      dashboards: [],
      loading: false,
      openModal: false,
      activeDashboard: Object.assign({}, this.dashboardModel)
    }

    this.handleVisualize = this.handleVisualize.bind(this)
    this.handleToggleModal = this.handleToggleModal.bind(this)
    this.handleSaveDashboard = this.handleSaveDashboard.bind(this)
    this.handleChangeTitle = this.handleChangeTitle.bind(this)
    this.handleDeleteDashboard = this.handleDeleteDashboard.bind(this)
    this.getDashboards = this.getDashboards.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleUpdateDashboard = this.handleUpdateDashboard.bind(this)
  }

  componentDidMount() {
    this.getDashboards()
  }

  async getDashboards() {
    try {
      this.setState({ loading: true })
      const { items } = await this.dashboardService.paging({ unit: this.idUnit, limit: 100 })
      this.setState({ dashboards: items, loading: false })
    } catch (e) {
      this.setState({ loading: false })
    }
  }

  handleVisualize(item: any) {
    const { history } = this.props

    history.push(`/liteReports/${item.id}`)
  }

  handleToggleModal(edit: boolean = false, item: any = null) {
    if (edit && item) {
      item.groupId = item.groupId || []
    }

    const activeDashboard = edit === true ? item : Object.assign({}, this.dashboardModel)
    this.setState({
      activeDashboard,
      openModal: !this.state.openModal
    })
  }

  async handleSaveDashboard() {
    try {
      const { activeDashboard } = this.state
      const { title, groupId } = activeDashboard
      const { history } = this.props
      const created = await this.dashboardService.create({ title, groupId }, this.idUnit)

      NotificationComponent.Notify('success', I18n.l("common.success"), "Dashboard criado com sucesso!")

      this.handleToggleModal()
      history.push(`/liteReports/${created.id}`)
    } catch (e) {
      console.error(e)
      NotificationComponent.Notify('error', "Erro ao criar Dashboard!", e);
    }
  }

  async handleUpdateDashboard() {
    try {
      const { activeDashboard } = this.state
      const { title, groupId, id } = activeDashboard
      await this.dashboardService.update(id, { title, groupId }, this.idUnit)

      NotificationComponent.Notify('success', I18n.l("common.success"), "Dashboard editado com sucesso!")

      this.handleToggleModal()
      this.getDashboards()
    } catch (e) {
      console.error(e)
      NotificationComponent.Notify('error', "Erro ao editar Dashboard!", e);
    }
  }

  async handleDeleteDashboard(id: any) {
    try {
      await this.dashboardService.delete(id, this.idUnit)

      NotificationComponent.Notify('success', I18n.l("common.success"), "Dashboard apagado com sucesso!")

      this.getDashboards()
    } catch (e) {
      console.error(e)
      NotificationComponent.Notify('error', "Erro ao deletar Dashboard!", e);
    }
  }

  handleChangeTitle(e: any) {
    const activeDashboard = Object.assign({}, this.state.activeDashboard)
    activeDashboard.title = e.target.value
    this.setState({ activeDashboard })
  }

  handleCheckbox(id: any, e: any) {
    const activeDashboard = Object.assign({}, this.state.activeDashboard)
    const { groupId } = activeDashboard

    if (e.target.checked) {
      activeDashboard.groupId = [...groupId, id]
      this.setState({ activeDashboard })
    } else {
      const index = groupId.indexOf(id)
      
      if (index !== -1) {
        groupId.splice(index, 1)
        activeDashboard.groupId = groupId
        this.setState({ activeDashboard })
      }
    }
  }

  handleClickEdit(item: any) {
    this.handleToggleModal(true, item)
  }

  render() {
    const { dashboards, loading, openModal, activeDashboard } = this.state

    return <Wrapper>
      <div className="header">
        <h1 className="title">Dashboards</h1>
        {verifyItemPermission(null, 'can_create_dashboard', null, true) && <Button type="primary" onClick={this.handleToggleModal}>Novo Dashboard</Button>}
      </div>

      {!loading && <TableComponent
        columns={this.tableColumns}
        data={dashboards}
        showConfirmationModal={false}
        onVisualize={this.handleVisualize}
        onDelete={this.handleDeleteDashboard}
        onEdit={this.handleClickEdit}
        status={true}
        noPagination={true}
        editPermission="can_edit_dashboard"
        deletePermission="can_delete_dashboard"
        pillar={this.currentPillar}
        isDashboard
      />}

      {loading && <div>{I18n.l('common.loadingData')}</div>}

      <Modal
        visible={openModal}
        title={activeDashboard && activeDashboard.id ? I18n.l("dashboard.edit") : I18n.l("dashboard.create")}
        footer={false}
        closable={false}
        destroyOnClose={true}
      >
        <DashboardForm
          onToggleModal={this.handleToggleModal}
          onChangeTitle={this.handleChangeTitle}
          onSave={activeDashboard && activeDashboard.id ? this.handleUpdateDashboard : this.handleSaveDashboard}
          activeDashboard={activeDashboard}
          onCheckbox={this.handleCheckbox}
        />
      </Modal>
    </Wrapper>
  }
}

const DashboardList = withRouter(Dashboard)
export default DashboardList

const Wrapper = styled.div`
  flex: 1;
  padding: 40px 50px;
  margin-left: 180px;
  margin-top: 100px;
  max-width: 100%;
  width: 100%;

  .title {
    color: black;
    font-size: 48px;
    font-weight: bold;
    padding-bottom: 1rem;
    margin-bottom: 0;
  }

  .loading {
    display: block;
    margin-top: 30px;
  }
`;